import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Importe os componentes do site comercial
import MarketingLayout from './components/marketing/MarketingLayout';
import MarketingHomePage from './components/marketing/MarketingHomePage';
import MarketingHomePageNew from './components/marketing/MarketingHomePageNew';
import PoliticaPrivacidadePage from './components/marketing/PoliticaPrivacidadePage';
import TermosDeUsoPage from './components/marketing/TermosDeUsoPage';



// ✅ NOVO: Importe o componente de cadastro de fornecedor
import FornecedorCadastroPage from './components/marketing/FornecedorCadastroPage';



// Importe o seu aplicativo de gestão
import WebApp from './WebApp';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rotas do Site Comercial */}
        <Route path="/" element={<MarketingLayout />}>
          <Route index element={<MarketingHomePageNew />} />
          {/* Homepage anterior (mantida no sistema) */}
          <Route path="old" element={<MarketingHomePage />} />
          <Route path="new" element={<Navigate to="/" replace />} />
          <Route path="politica-privacidade" element={<PoliticaPrivacidadePage />} />
          <Route path="termos-de-uso" element={<TermosDeUsoPage />} />
        </Route>



        {/* ✅ NOVA ROTA: Cadastro de Fornecedor (fora do layout, página independente) */}
        <Route path="/cadastro-fornecedor" element={<FornecedorCadastroPage />} />



        {/* Rota para o Aplicativo de Gestão */}
        <Route path="/app/*" element={<WebApp />} />

        {/* Catch-all para rotas não encontradas */}
        <Route path="*" element={<div className="flex items-center justify-center min-h-screen text-gray-600">404 - Página não encontrada</div>} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;

